import { CheckCircle } from 'lucide-react'
import { motion } from 'framer-motion'

export default function Success() {
    return (
        <div className="min-h-screen bg-gradient-to-br from-green-50 to-green-100 flex items-center justify-center p-4">
            <motion.div 
                initial={{ opacity: 0, y: 20 }}
                animate={{ opacity: 1, y: 0 }}
                transition={{ duration: 0.5 }}
                className="bg-card rounded-lg shadow-xl p-8 max-w-md w-full text-center"
            >
                <motion.div
                    initial={{ scale: 0 }}
                    animate={{ scale: 1 }}
                    transition={{ delay: 0.2, type: "spring", stiffness: 200 }}
                >
                    <CheckCircle className="w-16 h-16 text-good mx-auto mb-4" />
                </motion.div>
                <motion.h1 
                    initial={{ opacity: 0 }}
                    animate={{ opacity: 1 }}
                    transition={{ delay: 0.4 }}
                    className="text-3xl font-bold text-foreground mb-4"
                >
                    Payment Successful!
                </motion.h1>
                <motion.p 
                    initial={{ opacity: 0 }}
                    animate={{ opacity: 1 }}
                    transition={{ delay: 0.6 }}
                    className="text-muted-foreground mb-6"
                >
                    Thank you for your purchase. You will receive a confirmation email shortly.
                </motion.p>
                <motion.div
                    initial={{ opacity: 0 }}
                    animate={{ opacity: 1 }}
                    transition={{ delay: 0.8 }}
                >
                    <a 
                        href="/"
                        className="inline-block bg-good text-background px-6 py-3 rounded-lg font-semibold hover:bg-good transition-colors duration-200"
                    >
                        Home
                    </a>
                </motion.div>
            </motion.div>
        </div>
    )
}